import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { Button } from 'reactstrap';
import { LoadingDots } from 'site-modules/shared/components/loading-dots/loading-dots';
import { useUrlFilterSync } from 'site-modules/lease-deals/hooks/use-url-filter-sync/use-url-filter-sync';
import { getPlural } from 'client/utils/plural';

function FooterButtonsUI({ dealsCount = undefined, setModelValue, toggle }) {
  const onUpdate = useUrlFilterSync(setModelValue);
  const onClearAll = useCallback(() => {
    onUpdate({}, true);
  }, [onUpdate]);

  const isLoading = dealsCount === undefined;

  return (
    <>
      <Button
        color="link"
        className="size-16 text-transform-none text-decoration-underline fw-normal p-0"
        onClick={onClearAll}
      >
        Clear All
      </Button>

      <Button
        color="blue-50"
        className="pos-r size-16 text-transform-none fw-medium rounded-5 px-1_5 py-0_5"
        onClick={toggle}
      >
        {isLoading && <LoadingDots dotClassName="bg-white" className="pos-a center-xy" />}
        <span className={isLoading ? 'invisible' : 'visible'}>
          Show {dealsCount} {getPlural('Result', dealsCount)}
        </span>
      </Button>
    </>
  );
}

FooterButtonsUI.displayName = 'FooterButtonsUI';
FooterButtonsUI.propTypes = {
  dealsCount: PropTypes.number,
  setModelValue: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
};

const stateToPropsConfig = {
  dealsCount: bindToPath(
    LeaseDealsPaths.getLeaseDealsPath(),
    LeaseDealsModel,
    ({ topDealsByModelCount }) => topDealsByModelCount,
    false
  ),
};

export const FooterButtons = connectToModel(FooterButtonsUI, stateToPropsConfig);
